"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/OverflowSet/index"), exports);
//# sourceMappingURL=OverflowSet.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/OverflowSet.js
// module id = 1441
// module chunks = 0